import React, { FC } from 'react';
import { Pane, PaneProps } from 'evergreen-ui';

import {
  CellMeasurerCache,
  AutoSizer as _AutoSizer,
  List as _List,
  CellMeasurer as _CellMeasurer,
  ListProps,
  AutoSizerProps,
  CellMeasurerProps,
  ListRowRenderer,
} from 'react-virtualized';
import { createUseStyles } from 'react-jss';

import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { generalStationsStyles } from './useStyles';
import { StationNavigationRow } from './Station/Components';
import DatasourcesTable from './Datasources/Components/DatasourcesTable';
import { useFakeLoading } from './Hooks/useFakeLoading';

// note: по решению проблемы: https://github.com/bvaughn/react-virtualized/issues/1739
const List = _List as unknown as FC<ListProps>;
const AutoSizer = _AutoSizer as unknown as FC<AutoSizerProps>;
const CellMeasurer = _CellMeasurer as unknown as FC<CellMeasurerProps>;

const useStyles = createUseStyles({
  row: generalStationsStyles.tableRow,
  stationRow: {
    backgroundColor: '#f2f3f6',
    '&:hover': {
      backgroundColor: '#efefef',
    },
  },
});

type StationsFullTableProps = PaneProps & {
  stationsIds: number[],
}
/** 
 * Таблица станций с их источникам и статусами источников.
 * 
 * Отрисовка по словарям приложения из `redux-store`.
 * (с виртуализацией по станциям)
 * */
export function StationsFullTable({
  stationsIds = [], ...props
}: StationsFullTableProps) {
  const classes = useStyles();
  const isLoadingPage = useFakeLoading();

  const cacheRef = new CellMeasurerCache({
    minHeight: 50,
    fixedWidth: true,
  });

  const stationFullRow: ListRowRenderer = ({
    index, key, parent, style,
  }) => {
    const stationId = stationsIds[index];
    return (
      <CellMeasurer
        key={key}
        cache={cacheRef}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div style={style}>
          <Pane>
            <StationNavigationRow className={`${classes.row} ${classes.stationRow}`} stationId={stationId} />
            <DatasourcesTable withFilter stationId={stationId} />
          </Pane>
        </div>
      </CellMeasurer>
    );
  };

  if (isLoadingPage) return <SuspenseSpinner />;
  return (
    <Pane
      height="100%"
      minHeight="100px"
      width="100%"
      {...props}
    >
      <AutoSizer
        onResize={() => cacheRef.clearAll()}
      >
        {
          ({ width, height }) => {
            return (
              <List
                className="virtualized-outline"
                rowCount={stationsIds.length}
                width={width}
                height={height}
                deferredMeasurementCache={cacheRef}
                rowHeight={cacheRef.rowHeight}
                rowRenderer={stationFullRow}
                // overscanRowCount={3}
              />
            );
          }
        }
      </AutoSizer>
    </Pane>
  );
}
export const MemoStationsFullTable = React.memo(StationsFullTable);
MemoStationsFullTable.displayName = 'MemoStationsFullTable';
export default StationsFullTable;
